import script from "./SuperAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuperAdmin.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__